module.exports = __webpack_public_path__ + "img/ch13_01_初见大海.67612cbc.jpg";